import Vue from "vue";
import Router from "vue-router";
import Strategy from "./Strategy.vue";
import User from "./User.vue";
import Activity from "./Activity.vue";
import Observation from "./Observation.vue";
import ObservationCreate from "./ObservationCreate.vue";
import ActivitySubmission from "./ActivitySubmission.vue";
import ActivitySubmissionLearner from "./ActivitySubmissionLearner.vue";
import Submissions from "./Submissions.vue";
import RubricSubmissions from "./RubricSubmissions.vue";
import BestPractices from "./BestPractices.vue";
import TeacherDashboard from "./TeacherDashboard.vue";
import Dashboard from "./Dashboard.vue";
import Profile from "./Profile.vue";
import AdminProgress from "./AdminProgress.vue";
import Ready from "./views/Ready.vue";
import Set from "./views/Set.vue";
import SetThanks from "./components/SetThanks";
import GoThanks from "./components/GoThanks";
import GoThanksCompleted from "./components/GoThanksCompleted";
import FbError from "./components/FbError";
import Go from "./views/Go.vue";
import Observations from "./Observations.vue";
import ObservationThanks from "./components/ObservationThanks";
import AssignmentCreate from "./AssignmentCreate";
import Assignments from "./Assignments";
import CoachDashboard from "./CoachDashboard.vue";
import CoachHome from "./CoachHome.vue";
import LearnerHome from "./LearnerHome.vue";
import LearnerProgress from "./LearnerProgress.vue";
import ExperiencePathReport from "./ExperiencePathReportPage";

// import Description from "./views/Description.vue";
import FbInfoView from "./components/Form/FbInfoButton/FbInfoView.vue";
import ActivityThanks from "./components/ActivityThanks";
import ActivityThanksCompleted from "./components/ActivityThanksCompleted";
import AssignmentSubmission from "./AssignmentSubmission";
import AssignmentSubmissionReview from "./AssignmentSubmissionReview";
import AssignedCreate from "@/AssignedCreate";
import AssignedActivity from "./AssignedActivity";
import PreRequisite from "./PrerequisitePage";
import NotAvailable from "./NotAvailable";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/strategy",
      name: "strategy",
      // component: () => import( /* webpackChunkName: "startegy" */ "./Strategy.vue"),
      component: Strategy,
      children: [
        {
          path: ":id",
          component: Ready,
          name: "no_tab"
        },
        {
          path: ":id/ready",
          component: Ready,
          name: "field_ready_form"
        },
        {
          path: "/strategy/:id/ready/:component",
          name: "field_ready_form",
          component: FbInfoView
        },
        {
          path: ":id/set",
          component: Set,
          name: "field_set_form"
        },
        {
          path: ":id/set/thanks",
          component: SetThanks,
          name: "field_set_form"
        },
        {
          path: ":id/set/error",
          component: FbError,
          name: "field_set_form"
        },
        {
          path: ":id/go/thanks",
          component: GoThanks,
          name: "field_go_form"
        },
        {
          path: ":id/go/thanks/completed",
          component: GoThanksCompleted,
          name: "field_go_form"
        },
        {
          path: ":id/go/error",
          component: FbError,
          name: "field_go_form"
        },
        {
          path: "/strategy/:id/set/:component",
          name: "field_set_form",
          component: FbInfoView
        },
        {
          path: ":id/go",
          component: Go,
          name: "field_go_form"
        },
        {
          path: "/strategy/:id/go/:component",
          name: "field_go_form",
          component: FbInfoView
        }
      ]
    },
    {
      path: "/observation/add",
      name: "activity_form",
      component: ObservationCreate
    },
    {
      path: "/observation/:id",
      name: "activity_form",
      component: Observation
    },
    {
      path: "/activity/:id",
      name: "activity_form",
      component: Activity
    },
    {
      path: "/activity/:id/thanks",
      component: ActivityThanks,
      name: "activity_form_thanks"
    },
    {
      path: "/activity/:id/error",
      component: FbError,
      name: "activity_form_error"
    },
    {
      path: "/activity/:id/:component",
      name: "activity_form",
      component: FbInfoView
    },
    {
      path: "/activity/:id/thanks/completed",
      component: ActivityThanksCompleted,
      name: "activity_form_thanks"
    },
    {
      path: "/observation/:id/thanks",
      component: ObservationThanks,
      name: "observation_form_thanks"
    },
    {
      path: "/observation/:id/error",
      component: FbError,
      name: "observation_form_error"
    },
    {
      path: "/observation-submission/:id",
      name: "observation-submission",
      component: Observation
    },
    {
      path: "/activity-submission/:id",
      name: "activity-submission",
      component: ActivitySubmission
    },
    {
      path: "/activity-submission-learner/:id",
      name: "activity-submission-learner",
      component: ActivitySubmissionLearner
    },
    {
      path: "/submissions",
      name: "submissions",
      component: Submissions
    },
    {
      path: "/rubric-submissions",
      name: "rubric-submissions",
      component: RubricSubmissions
    },
    {
      path: "/best-practices",
      //component: () => import( /* webpackChunkName: "bestpractices" */ "./BestPractices.vue"),
      component: BestPractices,
      name: "best-practices"
    },
    {
      path: "/teacher-dashboard",
      name: "teacher-dashboard",
      // component: () => import( /* webpackChunkName: "teacherdashboard" */ "./TeacherDashboard.vue"),
      // component: TeacherDashboard
      component: TeacherDashboard
    },
    {
      path: "/dashboard",
      name: "admin-dashboard",
      // component: () => import( /* webpackChunkName: "admindashboard" */ "./AdminDashboard.vue"),
      component: Dashboard
    },
    {
      path: "/user/login",
      // component: () => import( /* webpackChunkName: "userlogin" */ "./User.vue"),
      component: User
    },
    {
      path: "/user/reset/:user",
      // component: () => import( /* webpackChunkName: "userlogin" */ "./User.vue"),
      component: User
    },
    {
      path: "/user/password",
      // component: () => import( /* webpackChunkName: "userlogin" */ "./User.vue"),
      component: User
    },
    {
      path: "/user/password/success",
      // component: () => import( /* webpackChunkName: "userlogin" */ "./User.vue"),
      component: User
    },
    {
      path: "/profile",
      // component: () => import( /* webpackChunkName: "userlogin" */ "./Profile.vue"),
      component: Profile
    },
    {
      path: "/quiz/:quiz/result/:result",
      // component: () => import( /* webpackChunkName: "userlogin" */ "./Profile.vue"),
      component: Profile
    },
    {
      path: "/member/:user_id",
      // component: () => import( /* webpackChunkName: "userlogin" */ "./AdminProgress.vue"),
      component: AdminProgress
    },
    {
      path: "/observations",
      // component: () => import( /* webpackChunkName: "userlogin" */ "./AdminProgress.vue"),
      component: Observations
    },
    {
      path: "/assignment/add",
      name: "assignment_create",
      component: AssignmentCreate
    },
    {
      path: "/assignment/:id/edit",
      component: AssignmentCreate,
      name: "assignment_edit",
      props: { editMode: true }
    },
    {
      path: "/assigned/add/:nid",
      name: "assigned_create",
      component: AssignedCreate
    },
    {
      path: "/assigned/:id/edit",
      component: AssignedCreate,
      name: "assigned_edit",
      props: { editMode: true }
    },
    {
      path: "/assignments",
      name: "assignments",
      component: Assignments
    },
    {
      path: "/assignment-submission/:id",
      component: AssignmentSubmission,
      name: "assignment_submission"
    },
    {
      path: "/assignment-submission/:id/review",
      component: AssignmentSubmissionReview,
      name: "assignment_submission_review"
    },
    {
      path: "/assigned/:id",
      component: AssignedActivity,
      name: "assigned_activity"
    },
    /*{
      path: "/coach-dashboard",
      component: CoachDashboard
    }, */
    {
      path: "/coach",
      component: CoachHome
    },
    {
      path: "/learner",
      component: LearnerHome,
      name: "learner"
    },
    {
      path: "/learner/:user_id",
      component: LearnerProgress
    },
    {
      path: "/pre-requisite/:id",
      component: PreRequisite
    },
    {
      path: "/not-available/:id",
      component: NotAvailable
    },
    {
      path: "/experience-path-report",
      component: ExperiencePathReport
    }
  ]
});
